<div class="dealer-public">
  <!--
  <div class="seller-block">

    <div class="seller-block-profile">
      <div>
        <img class="seller-pic"
          [src]="(currentDealerImage != undefined) ? currentDealerImage : 'assets/images/autodeal_logo.png'" alt="Car Image"
          >
        </div>
        <div>
          <h4>{{ provider.fname }} {{ provider.lname }} - {{ provider.businessName }}</h4>
          <h6><mat-icon>location_on</mat-icon> {{ provider.cityResident }} - {{ provider.countryResident }} </h6>
          <div class="button-section">
            <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}"><mat-icon>calendar_month</mat-icon>Prendre rendez-vous</button>
          </div>
        </div>
      </div>

      <div class="seller-block-ratings">
        <div>
          <h4>Avis</h4>
          <h6>Description et autres</h6>
          <h3><mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">star</mat-icon> <span [style.font-size]="'40px'"> {{ provider.ratingsSummary.average.toFixed(2)}} </span> / 5.0</h3>
          <h6 class="ratings-recommended">
            <b>Recommendé</b> <br />
            {{100 * (provider.ratingsSummary.counts[4] +provider.ratingsSummary.counts[3]) / getSellerRatingsTotalCount()}} %
            de commentaires recommandés (note de 4 ou 5/5)
          </h6>
        </div>
        <div>
          <div *ngFor="let i of [5,4,3,2,1]" class="rating-details">
            <h5>{{i}},0 </h5><mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">star</mat-icon>
            <mat-progress-bar mode="determinate" value="{{100 * provider.ratingsSummary.counts[i-1] / getSellerRatingsTotalCount()}}"></mat-progress-bar>
            {{provider.ratingsSummary.counts[i-1]}}

          </div>
        </div>
      </div>
    </div> -->


    <div class="dealer-details">

      <div class="dealer-infos">

        <div class="dealer-block-profile">
          <div>
            <img class="seller-pic"
              [src]="(currentDealerImage != undefined) ? currentDealerImage : 'assets/images/autodeal_logo.png'" alt="Car Image"
              >
            </div>
            <div [style.text-align]="'center'">
              <h3>{{ provider.firstName }} {{ provider.lastName }} - {{ provider.businessName }}</h3>
              <!-- <h6><mat-icon>location_on</mat-icon> {{ provider.cityResident }} - {{ provider.countryResident }} </h6> -->

              <br />
              <div class="button-section">
                <button [disabled]="currentlyLogginUser.username === provider.username" mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="openAppointmentDialog();$event.stopPropagation()">
                  <mat-icon>today</mat-icon>Prendre rendez-vous
                </button>
              </div>
            </div>
          </div>

          <div>

            <h6><label>Enregistré depuis : </label> {{ dateFormat (provider.created )}} </h6>
            @if (provider.dealerType==DealerType.PROFESSIONAL) {
              <h6>
                <label>Entreprise : </label> {{ provider.businessName }} , {{ provider.businessType }}
              </h6>
            }
            <h6><label>Localisation: </label>{{ provider.cityResident}}, {{ getCountryName(provider.countryResident)}}
            <span class = "mini-flag">
              <img  class="mini-flag" src="assets/images/country-flags/{{provider.countryResident}}.png" alt="{{provider.countryResident}}">
            </span>
          </h6>
          <h6><label>Avis clients: </label> </h6>
          <h3>

            @for (r of provider.ratingsSummary.indicators; track r; let i = $index) {
              <span (click)="recordRating(i+1)">
                @if (r===1) {
                  <mat-icon>star</mat-icon>
                }
                @if (r!==1) {
                  <mat-icon> {{r===0?'star_outlined':'star_half'}}</mat-icon>
                }
              </span>
            }
            <span [style.font-size]="'40px'"> {{ provider.ratingsSummary.average.toFixed(2)}} </span> / 5.0

            <span [style.font-size]="'14px'" [style.font-weight]="'normal'">
              <button mat-button  class="simple-button" (click)="showDetails = !showDetails" cdkOverlayOrigin #trigger="cdkOverlayOrigin"> ({{ getSellerRatingsTotalCount()}} avis)</button>
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="trigger"
                [cdkConnectedOverlayOpen]="showDetails">

                <div class="ratings-details">
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{provider.ratingsSummary.counts[4]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[3]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[2]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[1]}})</h6>
                  <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[0]}})</h6>
                </div>
              </ng-template>
            </span>
          </h3>
          <h6 class="ratings-recommended">
            <b>Recommendé</b> <br />
            {{ (100 * (provider.ratingsSummary.counts[4] +provider.ratingsSummary.counts[3]) / getSellerRatingsTotalCount()).toFixed(2)}} %
            de commentaires recommandés
          </h6>
        </div>

        <div class="action-buttons">
          @if (currentlyLogginUser.username !== provider.username) {
            <button class="simple-button-keep" mat-button matTooltipPosition="above" matTooltip="Email Seller"
              (click)="openJobDialog(provider.username, '')" >
              <mat-icon>today</mat-icon> Prendre rdv
            </button>
          }

          @if (currentlyLogginUser.username !== provider.username) {
            <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Email Seller"
              (click)="openMessageFormDialog()" >
              <mat-icon>mail</mat-icon> Contacter ce vendeur
            </button>
          }

          @if (currentlyLogginUser.username !== provider.username) {
            <button matButton class="simple-button"  mat-button
              (click)="openReviewDialog('', -1);$event.stopPropagation()">
              Poster votre avis<mat-icon>rate_review</mat-icon>
            </button>
          }

        </div>


        <!-- <button type="submit" mat-button class="cta-button">

        Contacter ce vendeur


      </button> -->
    </div>

    <div class="dealer-contact">
      <div class="dealer-contact-details">
        <div>
          <h4>Services</h4>
          <h6 >
            @for (serv of provider.keepOffer.servicesProvided; track serv; let i = $index) {
              <label>{{getServiceTypeTitle(serv)}},&nbsp;</label>
            }
          </h6>
          <h4>Spécialités</h4>
          <h6>
            @for (mk of provider.keepOffer.specialtyMakes; track mk; let i = $index) {
              <label>{{mk}},&nbsp;</label>
            }
          </h6>
          @if (currentlyLogginUser.username !== provider.username) {
            <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Add to fav"
              (click)="toggleFavoriteProvider()" >
              <mat-icon> {{ isFavoriteProvider ? 'favorite' : 'favorite_outline' }}</mat-icon> {{ isFavoriteProvider ? 'Retirer' : 'Ajouter' }} favori
            </button>
          }
        </div>
        <div>
          <h4>Heures d'ouverture</h4>
          <h6>

            <label>Lundi à vendredi: </label>08h30 - 18h00<br />
            <label>Samedi: </label>08h30 - 14h00<br />
            <label>Dimanche: </label>Fermé

          </h6>
        </div>

      </div>
      &nbsp;
      <!--
      <app-branches-google-map
        [selectedBranch]="provider.geoLocation"
        [zoom]="13.5"

        >

      </app-branches-google-map> -->

      <!--
      [branches]="[provider.geoLocation]"
      <h3>
        Poster une revue
      </h3>
      <form #reviewForm="ngForm" class="review-form">

        <div class="form-line">
          <br />
          <span >Votre note:&nbsp;&nbsp;
            <span *ngFor="let r of userRatingIndicators; index as i" (click)="review.rate = i+1;">

              <mat-icon class="rate-icon" > {{review.rate>i ?'star':'star_outlined'}}</mat-icon>
            </span>
            ({{review.rate}})
          </span>

        </div>
        <br />


        <div class="form-line">
          <mat-form-field>
            <mat-label>Commentaire</mat-label>
            <textarea type="text" required matInput="" name ="comment" placeholder=""  [(ngModel)]="review.comment" ></textarea>
          </mat-form-field>
        </div>
        <div *ngIf="!currentlyLogginIn">
          <mat-form-field >
            <mat-label>Email</mat-label>
            <input type="email" required matInput="" name ="email" placeholder=""  [(ngModel)]="review.email" >
          </mat-form-field>
        </div>
        <div class="form-line">
          <mat-form-field class="half-line" *ngIf="!currentlyLogginIn">
            <mat-label>Nom</mat-label>
            <input type="text" required matInput="" name ="name" placeholder=""  [(ngModel)]="review.name" >
          </mat-form-field>

          <mat-checkbox class="half-line" mat-input="" name ="nameIsPublic" [(ngModel)]="review.nameIsPublic">
            <h6>Publier votre nom</h6>
          </mat-checkbox>
        </div>
        <div class="form-line" *ngIf="!currentlyLogginIn">
          <mat-form-field class="half-line">
            <mat-label>Pays</mat-label>
            <input type="text" required matInput="" name ="country" placeholder=""  [(ngModel)]="review.country" >
          </mat-form-field>

          <mat-form-field class="half-line">
            <mat-label>Ville</mat-label>
            <input type="text" required matInput="" name ="city" placeholder=""  [(ngModel)]="review.city" >
          </mat-form-field>

        </div>
        <button class="cta-button" mat-button (click)="recordReview()" [disabled]="(!reviewForm.valid || review.rate ==0)">
          Poster
        </button>
      </form> -->

    </div>
  </div>


  <div class="dealer-cars">
    <div class="dealer-cars-section">

      <h1>A Vendre ({{ (sameSellerCarsToBuy$ | async)!.length}})</h1>

      <app-car-card-list
        [cars]="sameSellerCarsToBuy"
        [businessLine]="CarBusinessLine.BUY"
        >

      </app-car-card-list>
    </div>

    <div class="dealer-cars-section">

      <h1>A Louer ({{ (sameSellerCarsToRent$ | async)!.length}})</h1>

      <app-car-card-list
        [cars]="sameSellerCarsToRent"
        [businessLine]="CarBusinessLine.RENT"
        >
      </app-car-card-list>
    </div>
  </div>


  <!-- <p>
  <label>Moyenne: </label>
  <span *ngFor="let r of provider.ratingsSummary.indicators; index as i" (click)="recordRating(i+1)">
    <mat-icon *ngIf="r===1">star</mat-icon>
    <mat-icon *ngIf="r!==1"> {{r===0?'star_outlined':'star_half'}}</mat-icon>
  </span>
  <b>{{ provider.ratingsSummary.average.toFixed(2)}} </b>


  ({{ getSellerRatingsTotalCount()}} avis)

</p> -->

<div class="reviews-top">
  <h1>Avis clients  ({{ provider.reviews.length }})</h1>

  @if (currentlyLogginUser.username !== provider.username) {
    <button matButton class="cta-button-buy"  mat-button
      (click)="openReviewDialog('', -1);$event.stopPropagation()">
      Poster votre avis<mat-icon>rate_review</mat-icon>
    </button>
  }

</div>

<div class="reviews">
  <!--
  <div class="">
    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{provider.ratingsSummary.counts[4]}})</h6>
    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[3]}})</h6>
    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[2]}})</h6>
    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[1]}})</h6>
    <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{provider.ratingsSummary.counts[0]}})</h6>
  </div> -->

  <div class="seller-block-ratings">
    <div>

      <h3><mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">star</mat-icon> <span [style.font-size]="'40px'"> {{ provider.ratingsSummary.average.toFixed(2)}} </span> / 5.0</h3>
      <h6 class="ratings-recommended">
        <b>Recommendé</b> <br />
        {{(100 * (provider.ratingsSummary.counts[4] +provider.ratingsSummary.counts[3]) / getSellerRatingsTotalCount() ).toFixed(2)}} %
        de commentaires recommandés (note de 4 ou 5/5)
      </h6>
    </div>
    <div>
      @for (i of [5,4,3,2,1]; track i) {
        <div class="rating-details">
          <h5>{{i}},0 </h5><mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">star</mat-icon>
          <mat-progress-bar mode="determinate" value="{{100 * provider.ratingsSummary.counts[i-1] / getSellerRatingsTotalCount()}}"></mat-progress-bar>
          {{provider.ratingsSummary.counts[i-1]}}
        </div>
      }
    </div>
  </div>

  <div>

    @for (rev of provider.reviews.slice().reverse() ; track rev; let i = $index) {
      <div class="review" >
        <div class="review-header">
          <!-- <h5> {{rev.raterId}} {{rev.name}} </h5>  -->
          <h5> {{rev.raterName}}</h5>
          <h5>
            @for (r of userRatingIndicators; track r; let j = $index) {
              <span>
                <mat-icon class="rate-icon" > {{rev.rate> j ?'star':'star_outlined'}}</mat-icon>
              </span>
            }
          </h5>
        </div>
        <div class="review-comment">
          <h6>{{rev.comment}}</h6>
          <div class="review-label">{{dateFormat(rev.created)}} - {{rev.city}}, {{rev.country}}</div>
        </div>
        <!-- <button *ngIf="currentlyLogginUser.username === provider.username && !(reply !== undefined && reply.comment !== null && reply.comment !== '')"
        matButton class="simple-button"  mat-button (click)="openReviewDialog(rev, provider.reviews.length- i-1) ;$event.stopPropagation()"
        >
        Répondre<mat-icon>rate_review</mat-icon>
      </button>  -->
      @for (reply of rev.replies; track reply; let i = $index) {
        <div>
          @if ( reply !== undefined && reply.comment !== null && reply.comment !== '') {
            <div class="review-reply">
              <span>({{reply!.dealerId}}): <b>{{reply!.comment}}</b></span>
              <span class="review-label">{{dateFormat(reply!.date)}}</span>
            </div>
          }
        </div>
      }
      @if (currentlyLogginUser.username !== '') {
        <button
          matButton class="simple-button"  mat-button (click)="openReviewDialog(rev, provider.reviews.length - i-1) ;$event.stopPropagation()"
          >
          Répondre<mat-icon>rate_review</mat-icon>
        </button>
      }
      <!-- <p><label>Note:</label>
      <span *ngFor="let r of userRatingIndicators; index as i">
        <mat-icon class="rate-icon" > {{rev.rate>i ?'star':'star_outlined'}}</mat-icon>
      </span>
    </p>
    <p><label>Commentaire:</label> {{rev.comment}}</p>
    <p><label>Nom:</label> {{rev.name}}</p>
    <p><label>Localisation: </label>{{rev.city}}, {{rev.country}}</p>
    <p><label>Date: </label>{{dateFormat(rev.created)}}</p> -->
  </div>
}
</div>
</div>
<!-- <h3>Véhicules trouvés ({{ (previewTotalCount$ | async)}})</h3>

<car-card-list
  [fetchingResults] ="(fetchingResults$ | async)!"
  [cars] ="(cars$ | async)!"
  [favorites] ="(myFavorites$ | async)!"
  [carImagesFolders] ="(carImagesFolders$ | async)!">

</car-card-list> -->

</div>